(() => {
  const SELECTOR = 'a[data-image-download="true"][data-download-url]';

  const getFilenameFromUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.href);
      const pathname = parsed.pathname || '';
      const last = pathname.split('/').pop() || '';
      return decodeURIComponent(last.split('?')[0]) || '';
    } catch {
      return '';
    }
  };

  const triggerBlobDownload = (blob, filename) => {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename || 'download';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  };

  const onClick = async (event) => {
    const link = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!link) return;

    const url = link.getAttribute('data-download-url') || link.getAttribute('href');
    if (!url) return;

    const scopeId = link.getAttribute('data-download-scope');
    if (scopeId) {
      const sectionEl = document.getElementById(`m-image-cards-${scopeId}`);
      if (sectionEl && !sectionEl.contains(link)) return;
    }

    event.preventDefault();

    const filenameFromUrl = getFilenameFromUrl(url);
    const preferredName = link.getAttribute('data-download-filename') || '';
    const filename = filenameFromUrl || preferredName || 'download';

    try {
      const response = await fetch(url, { credentials: 'omit', mode: 'cors' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      triggerBlobDownload(blob, filename);
    } catch {
      window.location.href = url;
    }
  };

  document.addEventListener('click', onClick, { capture: true });
})();
